export const GC_USER_ID = 'gc-user-id'
export const GC_AUTH_TOKEN = 'gc-auth-token'
export const GC_APP_ID = 'gc-app-id'